import 'svelte/internal/disclose-version';

One_line[$.FILENAME] = 'src/web/concepts/one_line.svelte';

import * as $ from 'svelte/internal/client';
import Booking from "./booking.svelte";

var root = $.add_locations(
	$.from_html(
		`
    <form class="flex flex-col gap-6">
      <label for="problem" class="font-display text-3xl md:text-6xl font-semibold tracking-tight">What slows your company down?</label>
      <input id="problem" class="field text-2xl md:text-4xl" placeholder="Our quotes take two hours each…"/>
      <button class="btn self-start">Tell us</button>
    </form>
  `,
		1
	),
	One_line[$.FILENAME],
	[[10, 4, [[11, 6], [12, 6], [13, 6]]]]
);

var root_1 = $.add_locations(
	$.from_html(
		`
    <div class="flex flex-col gap-2">
      <p class="opacity-60"> </p>
      <h1 class="font-display text-3xl md:text-5xl font-semibold tracking-tight">We can fix that. Let's talk face to face.</h1>
    </div>
    <!>
  `,
		1
	),
	One_line[$.FILENAME],
	[[16, 4, [[17, 6], [18, 6]]]]
);

var root_2 = $.add_locations(
	$.from_html(
		`

<div class="w-full max-w-4xl flex flex-col gap-10">
  <!>
</div>`,
		1
	),
	One_line[$.FILENAME],
	[[8, 0]]
);

function One_line($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, One_line);

	let problem = $.tag($.state(""), 'problem');
	let sent = $.tag($.state(false), 'sent');
	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root_2();
	var div = $.sibling($.first_child(fragment));
	var node = $.sibling($.child(div));

	{
		var consequent = ($$anchor) => {
			var fragment_1 = root();
			var form = $.sibling($.first_child(fragment_1));
			var input = $.sibling($.child(form), 3);

			$.remove_input_defaults(input);
			$.autofocus(input, true);

			var button = $.sibling(input, 2);

			$.next();
			$.reset(form);
			$.next();
			$.template_effect(($0) => button.disabled = $0, [() => !$.get(problem).trim()]);

			$.event('submit', form, function submit(e) {
				e.preventDefault();

				if ($.get(problem).trim()) $.set(sent, true);
			});

			$.bind_value(
				input,
				function get() {
					return $.get(problem);
				},
				function set($$value) {
					$.set(problem, $$value);
				}
			);

			$.append($$anchor, fragment_1);
		};

		var alternate = ($$anchor) => {
			var fragment_2 = root_1();
			var div_1 = $.sibling($.first_child(fragment_2));
			var p = $.sibling($.child(div_1));
			var text = $.only_child(p);

			$.next(3);
			$.reset(div_1);

			var node_1 = $.sibling(div_1, 2);

			{
				let $0 = $.derived(() => `Your problem: ${$.get(problem)}`);

				$.add_svelte_meta(
					() => Booking(node_1, {
						get summary() {
							return $.get($0);
						}
					}),
					'component',
					One_line,
					20,
					4,
					{ componentTag: 'Booking' }
				);
			}

			$.next();
			$.template_effect(() => $.set_text(text, `“${$.get(problem) ?? ''}”`));
			$.append($$anchor, fragment_2);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if (!$.get(sent)) $$render(consequent); else $$render(alternate, -1);
			}),
			'if',
			One_line,
			9,
			2
		);
	}

	$.next();
	$.reset(div);
	$.append($$anchor, fragment);

	return $.pop($$exports);
}

if (import.meta.hot) {
	One_line = $.hmr(One_line);

	import.meta.hot.accept((module) => {
		One_line[$.HMR].update(module.default);
	});
}

export default One_line;